import { useModel } from '../model'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '商品名称',
            fieldName: 'materialName',
            span: 5,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '商品编码',
            fieldName: 'materialCode',
            span: 5,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '商品分类',
            fieldName: 'typeName',
            span: 5,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '品牌',
            fieldName: 'brandName',
            span: 5,
        },
    ]

    return (
        <YhPageHeader
            title="drgrd"
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
